import { render, staticRenderFns } from "./UploadIDCard.vue?vue&type=template&id=791db757&scoped=true&"
import script from "./UploadIDCard.vue?vue&type=script&lang=js&"
export * from "./UploadIDCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadIDCard.vue?vue&type=style&index=0&id=791db757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791db757",
  null
  
)

export default component.exports